<mobi-breadcrumb />
<div class="mobi-ui-grid is-centered">
  <div
    class="max-w-full mobi-ui-col-1/1 mobi-ui-animation-appear-up-init mobi-ui-animation-appear-up-render is-delayed-300"
    [class]="{
      'xl:mobi-ui-col-3/4': entity().headerImage,
      'md:mobi-ui-col-2/3': !entity().headerImage,
      'xl:mobi-ui-col-1/2': !entity().headerImage,
    }"
  >
    @if (entity().superTitle) {
      <span class="mobi-ui-font-h4 mobi-ui-text-inked text-animation !pb-0">
        {{ entity().superTitle }}
      </span>
    }
    @if (entity().title) {
      <h1 class="mobi-ui-font-h1 text-animation">
        {{ entity().title }}
      </h1>
    }
  </div>
</div>

@if (entity().headerImage) {
  <div class="mobi-ui-grid is-centered">
    <div class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4">
      <div class="hero-image-animation-wrapper mobi-ui-margin-b-lg">
        <mobi-media
          [animation]="false"
          class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300"
          rounded="left"
          [entity]="entity().headerImage"
          [mobileEntity]="entity().headerImageMobile"
          responsiveStyle="hero_single"
          [lazy]="false"
        />
      </div>
    </div>
  </div>
}
<mobi-hero-text
  [subtitle]="entity().subtitle"
  [lead]="entity().lead"
  [contentLinks]="contentLinks()"
  [primaryCta]="entity().cta | extractUrl"
  [primaryCtaTitle]="entity().cta?.title"
  [primaryCtaIcon]="entity().ctaIcon"
/>
<div class="page-content">
  @if (entity().paragraphs) {
    @for (paragraph of entity().paragraphs; track paragraph?.uuid ?? $index) {
      @if (paragraph) {
        <mobi-paragraph-loader
          [bundle]="paragraph.type"
          [data]="{ paragraph: paragraph }"
        />
      }
    }
  }

  @defer (hydrate on viewport) {
    @if (entity().relatedContent?.length) {
      <div class="content-section is-background">
        <div>
          <mobi-related-content
            [teasers]="entity().relatedContent!"
            [title]="entity().relatedContentTitle"
            [description]="entity().relatedContentText"
          />
        </div>
      </div>
    }
  }
</div>
